export const HOLIDAY_SET_DEFAULT_ICON = 'calendar-star';
